import React, { Component } from 'react'
import {
  makeStyles,
  useTheme,
  Divider,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  table: {
    display: 'flex',
    justifyContent: 'space-evenly'
  },
  tableItems: {
    [theme.breakpoints.down('lg')]: {
      width: 100,
    },
    [theme.breakpoints.up('xl')]: {
      width: 150
    }
  }
}))

export default function SalesMultiplierTable(props) {
  const classes = useStyles()

  return (
    <div>
      {/* <Table style={{width: '100%'}}> */}
        {/* <TableHead>
          <TableRow style={{height: 50, backgroundColor: '#007ac9'}}>
            <TableCell align="center" style={{color: '#fff', fontWeight: 'bold'}}>SALES MULTIPLIER (INCREMENTAL)</TableCell>
          </TableRow>
        </TableHead> */}
        {/* <TableBody>
          <TableRow>
            {props.data.map(row => (
              <TableCell key={row.ProductName} align="center"><Typography variant="caption">{row.ProductName.toUpperCase()}</Typography></TableCell>
            ))}
          </TableRow>
          <TableRow>
            {props.data.map(row => (
              <TableCell key={row.ProductName} align="center">{row.Data[0].ROI_X}</TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table> */}
      <div style={{justifyContent: 'space-evenly', textAlign: 'center'}}>
        <div style={{display: 'flex', justifyContent: 'space-evenly', marginTop: '25px'}}>
          <div/>
          {props.data.map(row => (
            <div key={row.Key} className={classes.tableItems}>
              <Typography variant="caption">{row.ProductName.toUpperCase()}</Typography>
            </div>
          ))}
          <div/>
        </div>
        <br/>
        <Divider style={{marginTop: '5px', marginBottom: '5px'}}/>
        <br/>
        <div style={{display: 'flex', justifyContent: 'space-evenly'}}>
          <div/>
          {props.data.map(row => (
            <div key={row.Key} className={classes.tableItems}>
              <Typography variant="caption" style={{fontSize: '15px'}}>{row.Data[0].ROI_X ? '$' + row.Data[0].ROI_X : '$0'}</Typography>
            </div>
          ))}
          <div/>
        </div>
      </div>
    </div>
  )
}
